
    import './styles.scoped.css';
    export default {
  "show-grab-cursor": "awsui_show-grab-cursor_1fgk7_1xrvg_9",
  "show-resize-cursor": "awsui_show-resize-cursor_1fgk7_1xrvg_13",
  "disable-selection": "awsui_disable-selection_1fgk7_1xrvg_20"
};
  